import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';
import Spin from 'antd/lib/spin';

import { filePropTypes, constants as uploaderConstants } from 'modules/uploader';

import Image from '../Image';

import rule from './ImageMap.rule';

const ImageMap = ({ uid, url, status, firestoreId }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            {status === uploaderConstants.status.DONE && <Image id={uid} firestoreId={firestoreId} url={url} />}
            {status === uploaderConstants.status.UPLOADING && (
                <Spin tip={<FormattedMessage id="maps.imageMap.status.uploading" />} />
            )}
        </div>
    );
};

ImageMap.propTypes = {
    ...filePropTypes,
    firestoreId: PropTypes.string,
};

ImageMap.defaultProps = {
    firestoreId: null,
};

export default ImageMap;
